import React from "react";

export const Footer = (props) => {
  const contact = props.contact || {};
  const onHomeClick = (e, section = "page-top") => {
    if (props.onHome) {
      e.preventDefault();
      props.onHome(section);
    }
  };

  return (
    <footer id="site-footer" className="site-footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-col footer-brand-col">
            <a
              href="#page-top"
              className="footer-brand"
              onClick={onHomeClick}
              aria-label="GOLDLY AI home"
            >
              <img
                src="img/logo/logo-trim.png"
                alt="GOLDLY AI"
                className="footer-logo"
              />
            </a>
            <p className="footer-tagline">
              Enterprise AI agents for global operations, supported by
              multi-cloud infrastructure and governed model access.
            </p>
            <div className="footer-social">
              <a
                href={contact.whatsappQr || "img/contact/whatsapp-qr.jpg"}
                className="footer-social-whatsapp"
                aria-label="WhatsApp"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fa fa-whatsapp" />
                <span className="footer-whatsapp-qr" aria-hidden="true">
                  <img
                    src={contact.whatsappQr || "img/contact/whatsapp-qr.jpg"}
                    alt=""
                  />
                </span>
              </a>
              <a
                href={
                  contact.linkedin ||
                  "https://www.linkedin.com/in/goldlyfranksun"
                }
                aria-label="LinkedIn"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fa fa-linkedin" />
              </a>
              <a
                href={
                  contact.telegram
                    ? `https://t.me/${contact.telegram.replace("@", "")}`
                    : "https://t.me/xfrank404"
                }
                aria-label="Telegram"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fa fa-paper-plane" />
              </a>
            </div>
          </div>

          <div className="footer-col">
            <h4 className="footer-heading">Products</h4>
            <ul className="footer-list">
              <li>
                <a
                  href="https://tokenshengsheng.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Shengsheng Token
                </a>
              </li>
              <li>
                <a
                  href="https://tokenwenwen.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Wenwen Token
                </a>
              </li>
              <li>
                <a
                  href="https://pandasrouter.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  PandasRouter
                </a>
              </li>
              <li>
                <a
                  href="https://shiyeagent.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Shiye Agent
                </a>
              </li>
              <li>
                <a
                  href="https://agent.thinkloop.me"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Super Agent
                </a>
              </li>
              <li>
                <a
                  href="https://aisport.one"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  AI Sport
                </a>
              </li>
            </ul>
          </div>

          <div className="footer-col">
            <h4 className="footer-heading">Company</h4>
            <ul className="footer-list">
              <li>
                <a href="#/agent-platform">
                  AI Agents
                </a>
              </li>
              <li>
                <a href="#services" onClick={(event) => onHomeClick(event, "services")}>
                  Solutions
                </a>
              </li>
              <li>
                <a href="#testimonials" onClick={(event) => onHomeClick(event, "testimonials")}>
                  Customer Cases
                </a>
              </li>
              <li>
                <a href="#/insights">
                  Insights
                </a>
              </li>
              <li>
                <a href="#team" onClick={(event) => onHomeClick(event, "team")}>
                  Global Presence
                </a>
              </li>
              <li>
                <a href="#contact" onClick={(event) => onHomeClick(event, "contact")}>
                  Contact
                </a>
              </li>
            </ul>
          </div>

          <div className="footer-col">
            <h4 className="footer-heading">Contact</h4>
            <ul className="footer-list footer-contact">
              <li>
                <i className="fa fa-map-marker" />
                <span>
                  {contact.address ||
                    "135 MIDDLE ROAD, #02-16, BYLANDS BUILDING, SINGAPORE 188975"}
                </span>
              </li>
              <li>
                <i className="fa fa-globe" />
                <a
                  href="https://goldly.ai"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  goldly.ai
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copy">
            © 2026 CLOUD GOLD PTE. LTD. (UEN: 202606352W). "Goldly AI" is our
            brand. All rights reserved.
          </p>
          <ul className="footer-legal">
            <li>
              <a
                href="https://goldly.ai"
                target="_blank"
                rel="noopener noreferrer"
              >
                Privacy
              </a>
            </li>
            <li>
              <a
                href="https://goldly.ai"
                target="_blank"
                rel="noopener noreferrer"
              >
                Terms
              </a>
            </li>
            <li>
              <a
                href="https://goldly.ai"
                target="_blank"
                rel="noopener noreferrer"
              >
                Security
              </a>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
};
